import * as Yup from 'yup';
import { isNoTaxScheme } from '../constants/defaults';

/**
 * UAE party_tax_scheme rules:
 * 1. Tax scheme + VAT number → validate VAT format
 * 2. Tax scheme only (no VAT) → no VAT validation; submit strips party_tax_scheme in form handler
 * 3. VAT number without tax scheme → error on tax_scheme
 */
export const partyTaxSchemeShape = (m = {}) => ({
  tax_scheme: Yup.string()
    .nullable()
    .transform((v) => (isNoTaxScheme(v) ? null : v))
    .test(
      'tax-scheme-required-with-vat',
      m.tax_scheme_required_when_vat || 'Tax scheme must be selected when VAT number is entered',
      function (value) {
        const companyId = this.parent?.company_id;
        if (companyId == null || String(companyId).trim() === '') {
          return true;
        }
        return !isNoTaxScheme(value);
      },
    ),
  company_id: Yup.string()
    .nullable()
    .transform((v) => (v === '' ? null : v))
    .test('vat-length', m.VAT_length || 'VAT must be 15 characters', function (value) {
      if (!value || isNoTaxScheme(this.parent?.tax_scheme)) {
        return true;
      }
      return value.length === 15;
    })
    .test('vat-numeric', 'VAT must contain only numbers', function (value) {
      if (!value || isNoTaxScheme(this.parent?.tax_scheme)) {
        return true;
      }
      return /^\d+$/.test(value);
    })
    .test('vat-format', m.VAT_format || 'VAT must start with 1 and end with 03', function (value) {
      if (!value || isNoTaxScheme(this.parent?.tax_scheme)) {
        return true;
      }
      return /^1.*03$/.test(value);
    }),
});
